import { ConfigModel } from '../Model';
import { Config } from './type';

const DEFAULT_ENV = 'dev01';
const LOCAL_HOST = 'localhost';
const LOCAL_ENV = 'dev01';
const ENVIRONMENTS = 'environments';
const ENVIRONMENT_MAPPING = 'environmentMapping';

// const prodBeta = "qa01";

const getEnvConfigKey = (data: Config): ConfigModel => {
  const host = window.location.hostname;
  const updateHost = host.replace('www.', '');
  const environmentObject = data[ENVIRONMENTS];
  const environmentKeys = Object.keys(environmentObject);
  const environmentMapping = data[ENVIRONMENT_MAPPING];
  const configKey = environmentKeys.find(
    (envKey: string) => environmentObject[envKey] === updateHost,
  );
  // if (configKey && xFeatureAccess) {
  //     return data[prodBeta];
  // } else
  if (configKey && configKey === LOCAL_HOST) {
    return data[LOCAL_ENV];
  } else if (configKey) {
    return data[environmentMapping[configKey] as keyof Config] as ConfigModel;
  } else {
    return data[DEFAULT_ENV];
  }
};

export { getEnvConfigKey };
